import React from 'react';
import { Box, CircularProgress, TextField } from '@mui/material';
import DialogModal from '../../components/DialogModal';
import { EditAcademicYearDialogProps } from './types/AcademicYearTypes';
import { ActionButton, StyledTextField, TableHeaderRow } from './styled';

const EditAcademicYearDialog: React.FC<EditAcademicYearDialogProps> = ({
  open,
  title,
  rows,
  isSaving,
  onClose,
  onSave,
  updateRow,
  errors
}) => {
  const row = rows[0];
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (row) updateRow(row.id, 'startDate', e.target.value);
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (row) updateRow(row.id, 'endDate', e.target.value);
  };

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title={title}
      maxWidth='sm'
      actions={
        <TableHeaderRow>
          <ActionButton
            onClick={onClose}
            disabled={isSaving}
            variant='contained'
          >
            Cancel
          </ActionButton>
          <ActionButton
            onClick={onSave}
            disabled={isSaving}
            variant='contained'
          >
            {isSaving ? (
              <CircularProgress size={20} color='inherit' />
            ) : (
              'Save Changes'
            )}
          </ActionButton>
        </TableHeaderRow>
      }
    >
      <Box>
        <TextField label='Grade' value={row?.grade ?? ''} disabled fullWidth />
        <StyledTextField
          label='Start Date'
          type='date'
          InputLabelProps={{ shrink: true }}
          value={(row?.startDate || '').slice(0, 10)}
          onChange={handleStartDateChange}
          fullWidth
          error={Boolean(errors.startDate)}
          helperText={errors.startDate}
        />
        <StyledTextField
          label='End Date'
          type='date'
          InputLabelProps={{ shrink: true }}
          value={(row?.endDate || '').slice(0, 10)}
          onChange={handleEndDateChange}
          fullWidth
          error={Boolean(errors.endDate)}
          helperText={errors.endDate}
        />
      </Box>
    </DialogModal>
  );
};

export default EditAcademicYearDialog;
